import React, { useImperativeHandle, useRef } from 'react';
import styles from './styles.module.css';
import baseStyles from '../../styles.module.css';
import clsx from 'clsx';

type Props = React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> & {
  hasError?: boolean;
};

export const WisoryTextArea = React.forwardRef<HTMLTextAreaElement, Props>(
  ({ className, hasError, ...otherProps }, outerRef) => {
    const innerRef = useRef<HTMLTextAreaElement>(null);
    useImperativeHandle(outerRef, () => innerRef.current!, []);

    return (
      <textarea
        ref={innerRef}
        className={clsx(baseStyles.baseWrapper, styles.textAreaWrapper, className, {
          [baseStyles.error]: hasError,
        })}
        {...otherProps}
      />
    );
  }
);

WisoryTextArea.displayName = 'WisoryTextArea';
